import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ApplicationConst} from '../../routing/routingConst';
import {StorageService} from '../../services/storage/storage.service';
import {TranslateService} from '@ngx-translate/core';
import {AuthenticationService} from '../../services/apiServices/security/authentication.service';
import {KindOfUpload} from './upload/helpers/kind-of-upload.enum';
import {environment} from '../../../environments/environment';
import {User} from '../../model/user';
import {CommonService} from '../../services/apiServices/business/common.service';
import {DepositDepotExpressEnum} from "../../enums/deposit.enums";

/**
 * shell that handleChangeOfSelectFold the display of the application when the user is connected
 */
@Component({
  selector: 'app-application-container',
  templateUrl: './application-container.component.html',
  styleUrls: ['./application-container.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ApplicationContainerComponent implements OnInit {

  public user: User;
  /**
   * if the user click on change password
   */
  public displayConfig: boolean;
  public displayVirtualPrinterModal: boolean;
  public displayActionLogging: boolean;
  public displayUploadVirtualPrinterPanel: boolean;
  public displayUserManagement: boolean;
  public instance: string;
  /**
   * if the user click on uploading documents
   */
  public displayUpload: boolean;
  public displayUploadExpress: boolean;
  public displayTracking: boolean;
  private invalidFileMessageTitle: string;
  private invalidFileMessage: string;
  /**
   * represent the kind of upload that the user wants
   */
  public kindOfUpload: string;
  public modalTitle: string;
  public modalTitleExpressDefault: string;
  public modalTitleExpress: string;
  public modalTitleExpressUnit: string;
  public modalTitleExpressLre: string;
  public modalTitleExpressMailing: string;
  public modalTitleExpressSpool: string;
  /**
   *
   * default constructor that use the route (it'll be useful to display upload directly if the url match)
   *
   * @param {ActivatedRoute} route - routing handling on upload
   * @param storage
   * @param translate
   * @param commonService
   * @param authenticationService
   */
  constructor(private route: ActivatedRoute, private storage: StorageService, private translate: TranslateService, private commonService: CommonService,
              private  authenticationService: AuthenticationService ) {
    this.displayUploadVirtualPrinterPanel = false;
  }

  /**
   * handle the url onInit, if it's upload, the component will display the upload component directly
   */
  public ngOnInit(): void {
    this.user = this.authenticationService.getCurrentUser();

    this.instance = environment.instance;
    this.kindOfUpload = KindOfUpload.LETTER;
    this.translate.get('APPLICATION.CONTAINER_COMPONENT.MODAL_UPLOAD_NOTSET_HEADER').subscribe((label: string) => {
      this.modalTitle = label;
    });
    this.translate.get('APPLICATION.CONTAINER_COMPONENT.MODAL_UPLOAD_EXPRESS').subscribe((label: string) => {
      this.modalTitleExpressDefault = label;
      this.modalTitleExpress = this.modalTitleExpressDefault;
    });
    this.translate.get('UPLOAD_COMPONENT.EXPRESS_DEPOSIT_UNIT').subscribe((label: string) => {
      this.modalTitleExpressUnit = label;
    });
    this.translate.get('UPLOAD_COMPONENT.EXPRESS_DEPOSIT_ERL').subscribe((label: string) => {
      this.modalTitleExpressLre = label;
    });
    this.translate.get('UPLOAD_COMPONENT.EXPRESS_DEPOSIT_MAILING').subscribe((label: string) => {
      this.modalTitleExpressMailing= label;
    });
    this.translate.get('UPLOAD_COMPONENT.EXPRESS_DEPOSIT_SPOOL').subscribe((label: string) => {
      this.modalTitleExpressSpool= label;
    });
    this.translate.get('APPLICATION.CONTAINER_COMPONENT.INVALID_MESSAGE').subscribe((label: string) => {
      this.invalidFileMessage = label;
    });
    this.translate.get('APPLICATION.CONTAINER_COMPONENT.INVALID_MESSAGE_TITLE').subscribe((label: string) => {
      this.invalidFileMessageTitle = label;
    });
    if (this.route.snapshot.url[0]) {
      this.displayUpload = this.route.snapshot.url[0].path === ApplicationConst.uploadPath;
    }
    this.displayConfig = false;
    this.displayVirtualPrinterModal = false;
    this.displayActionLogging = false;
    this.displayTracking = true;
    this.displayUserManagement = false;
    this. checkPermissions();
  }

  public checkPermissions(): void {
    const user = this.storage.getCurrentUserInStorage();
    if (!user) {
      return;
    }
    this.displayTracking = user.permissions.trackingDepot.available;
    this.displayUpload = !user.permissions.trackingDepot.available;
    this.displayUploadExpress = !user.permissions.trackingDepot.available;
/*    if (user && user.permissions) {
      const permissions = user.permissions;
      /!*if (permissions.orgFonctHabilUtil && permissions.orgFonctHabilUtil.listObjOrgFonctHabil) {
      }*!/
        for (const permission of permissions) {
          if ('TrackingDepot' === permission.sFonctId) {
            this.displayTracking = permission.bAccess;
            this.displayUpload = !this.displayTracking;
            return;
          }
        }

    }*/
  }
  /**
   * handleChangeOfSelectFold the change of display of the changePassword component
   *
   * @param {boolean} myValue - if the component needs to display the changePassword component
   */
  public handleParamDialog(myValue: boolean): void {
    this.displayConfig = myValue;
  }
  /**
   * handleOpenActionLogging the change of display of the actionLogging component
   *
   * @param {boolean} myValue - if the component needs to display the actionLogging component
   */
  public handleOpenActionLogging( myValue: boolean ): void {
    this.displayActionLogging = myValue;
  }
  public closeActionLoggingModal(): void {
    this.displayActionLogging = !this.displayActionLogging;
  }

  /**
   * handleChangeOfSelectFold the change of display of the changePassword component
   *
   * @param {boolean} myValue - if the component needs to display the uploadVirtualPrinter component
   */
  public handleVirtualPrinter( myValue: boolean ): void {
    this.displayVirtualPrinterModal = myValue;
  }
  public closeVirtualPrinterModal(): void {
    this.displayVirtualPrinterModal = !this.displayVirtualPrinterModal;
  }
  /*public afficherUploadVirtualPrinterPane(): void {
    this.displayUploadVirtualPrinterPanel = true;
  }*/
  /**
   * set the correct kind of modal for upload
   * @param {number} myValue - the wished type of upload modal
   */
  public handleOpenModal(myValue: string): void {
    if ('EXPRESS' === myValue) {
      this.displayUploadExpress = true;
    }
    else {
      this.kindOfUpload = myValue;
      this.displayUpload = true;
    }
  }


  public handleCloseModal(display: boolean): void {
    this.displayUpload = display;
  }
  public handleCloseModalExpress(display: boolean): void {
    this.displayUploadExpress = display;
  }
  public showUserManagement(showIt: boolean): void {
    this.displayUserManagement = showIt;
  }
  /**
   * Fire close modal event
   */
  public closeUpload(): void {
    this.displayUpload = false;
  }
  onFilesChange(fileList: Array<File>): void {
    if (fileList && fileList.length < 0) {

    }
  }
  onFileInvalids(fileList: Array<File>): void {
    let files = ':';
    for (const file of fileList) {
      files = files + '<br>' + file.name;
    }
    this.commonService.addToast({
      life: 3000,
      severity: 'success',
      summary: this.invalidFileMessageTitle,
      detail: this.invalidFileMessage  + files
    });
  }
  public enableUploadModal(showComponent): void {
    if (showComponent) {
      this.kindOfUpload = KindOfUpload.LETTER;
      this.displayUpload = true;
    }
  }

  updateExpressDialogTitle(value: string) {
    switch (value) {
      case DepositDepotExpressEnum.UNIT:
        this.modalTitleExpress = this.modalTitleExpressUnit;
        break;
      case DepositDepotExpressEnum.MAILING:
        this.modalTitleExpress = this.modalTitleExpressMailing;
        break;
      case DepositDepotExpressEnum.SPOOL:
        this.modalTitleExpress = this.modalTitleExpressSpool;
        break;
      case DepositDepotExpressEnum.ERL:
        this.modalTitleExpress = this.modalTitleExpressLre;
        break;
      default:
        this.modalTitleExpress = this.modalTitleExpressDefault;
        break;
    }
  }
}
